import { useMutation } from "@tanstack/react-query";
import { useAuth, authorizedAxios } from "@moonscape/shared";

/**
 * This hook is only used for insert a NEW txn to txns table and DELETE/RESTORE txns
 * DO NOT use this hook for UPDATE txn's value
 **/
export const useTxn = ({ onSuccess, onError }) => {
  const { getToken } = useAuth();

  return useMutation({
    mutationFn: async (txn: any) => {
      const token = await getToken();
      //   try {
      if (txn?.ext_txn_id) {
        // update case only for delete/restore because we use user_txn_value table to store values from users
        return await authorizedAxios(token).delete(
          `/transaction/${txn?.ext_txn_id}`
        );
      } else if (txn) {
        // insert case
        return await authorizedAxios(token).post(`/transaction`, txn);
      }
    },
    onSuccess: () => {
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (err) => {
      if (onError) {
        onError();
      }
      console.log("[useTxn] Error", err);
    },
  });
};
